/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Point } from "../../popover/common/popover";
import { RowActionService } from "./providers/row-action-service";
var DatagridActionOverflow = (function () {
    function DatagridActionOverflow(rowActionService) {
        this.rowActionService = rowActionService;
        this.anchorPoint = Point.RIGHT_CENTER;
        this.popoverPoint = Point.LEFT_CENTER;
        /**
         * Tracks whether the action overflow menu is open or not
         */
        this._open = false;
        this.openChanged = new EventEmitter(false);
        this.rowActionService.register();
    }
    DatagridActionOverflow.prototype.ngOnDestroy = function () {
        this.rowActionService.unregister();
    };
    Object.defineProperty(DatagridActionOverflow.prototype, "open", {
        get: function () {
            return this._open;
        },
        set: function (open) {
            var boolOpen = !!open;
            if (boolOpen !== this._open) {
                this._open = boolOpen;
                this.openChanged.emit(boolOpen);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Shows/hides the action overflow menu
     */
    DatagridActionOverflow.prototype.toggle = function (event) {
        this.openingEvent = event;
        this.open = !this.open;
    };
    DatagridActionOverflow.prototype.close = function (event) {
        /*
         * Because this listener is added synchonously, before the event finishes bubbling up the DOM,
         * we end up firing on the very click that just opened the menu, p
         * otentially closing it immediately every time. So we just ignore it.
         */
        if (event === this.openingEvent) {
            delete this.openingEvent;
            return;
        }
        this.open = false;
    };
    return DatagridActionOverflow;
}());
export { DatagridActionOverflow };
DatagridActionOverflow.decorators = [
    { type: Component, args: [{
                selector: "clr-dg-action-overflow",
                template: "\n        <clr-icon #anchor shape=\"ellipsis-vertical\" class=\"datagrid-action-toggle\" (click)=\"toggle($event)\"></clr-icon>\n        <ng-template [(clrPopover)]=\"open\" [clrPopoverAnchor]=\"anchor\" [clrPopoverAnchorPoint]=\"anchorPoint\"\n             [clrPopoverPopoverPoint]=\"popoverPoint\">\n            <div #menu class=\"datagrid-action-overflow\" (clrOutsideClick)=\"close($event)\" [clrStrict]=\"true\">\n                <ng-content></ng-content>\n            </div>\n        </ng-template>\n    "
            },] },
];
/** @nocollapse */
DatagridActionOverflow.ctorParameters = function () { return [
    { type: RowActionService, },
]; };
DatagridActionOverflow.propDecorators = {
    'open': [{ type: Input, args: ["clrDgActionOverflowOpen",] },],
    'openChanged': [{ type: Output, args: ["clrDgActionOverflowOpenChange",] },],
};
//# sourceMappingURL=datagrid-action-overflow.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/datagrid/datagrid-action-overflow.js
// module id = 154
// module chunks = 4